import { render, staticRenderFns } from "./EventBlock.vue?vue&type=template&id=519f8504&scoped=true&"
import script from "./EventBlock.vue?vue&type=script&lang=js&"
export * from "./EventBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "519f8504",
  null
  
)

export default component.exports